// Static assets CDN origin per NEXT_PUBLIC_ENVIRONMENT, no trailing slash.
// Shared by next.config.js (CommonJS) and app/moment-env.ts.
const ASSETS_ORIGINS = {
  staging: 'https://assets.staging.moment.com',
  'prod-ppr': 'https://assets.paper.moment.com',
  prod: 'https://assets.moment.com',
}

function assetsOrigin(environment) {
  return environment && Object.hasOwn(ASSETS_ORIGINS, environment)
    ? ASSETS_ORIGINS[environment]
    : ''
}

module.exports = { assetsOrigin }
